import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/despesaDireta' };
/////////////////////////////////////////////////////////////////////////////////

export function createDespesaDiretaCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateDespesaDiretaCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listDespesaDiretaCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findDespesaDiretaCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function deleteDespesaDiretaCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

